import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { inputStyle, buttonStyleBlue } from '../styles';

function Login({ onSwitchToSignup }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const logIn = async () => {
    if (!email || !password) {
      alert('Please enter both email and password');
      return;
    }

    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Don't navigate - AuthContext will handle the state change
      // and App.js will automatically show the platform selection
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) return alert("Please enter your email.");
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent!");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 24,
      boxSizing: 'border-box'
    }}>
      <div style={{
        width: '100%',
        maxWidth: 520,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '44px 40px',
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          width: '100%',
          textAlign: 'center',
          boxSizing: 'border-box'
        }}>
          <img 
            src="https://promogrindmaterials.s3.us-west-1.amazonaws.com/Promogrindlogo93494.jpg" 
            alt="PromoGrind Logo" 
            style={{ width: 120, marginBottom: 20 }} 
          />
          <h1 style={{ margin: '0 0 10px 0', color: '#333' }}>Grow Your Social Media</h1>
          <p style={{color: '#666', marginBottom: 20}}>Join thousands of creators boosting their reach</p>

          <input 
            type="email" 
            placeholder="Email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)} 
            style={inputStyle}
            disabled={loading}
          />
          <input 
            type="password" 
            placeholder="Password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)} 
            style={inputStyle}
            disabled={loading}
            onKeyPress={(e) => e.key === 'Enter' && logIn()}
          />

          <button 
            onClick={logIn} 
            style={{
              ...buttonStyleBlue,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
            disabled={loading}
          >
            {loading ? '🔄 Logging In...' : 'Log In'}
          </button>
          
          <p style={{ marginTop: 20 }}>
            Don't have an account?{' '}
            <span 
              style={{ 
                color: '#673AB7', 
                cursor: 'pointer',
                textDecoration: 'underline'
              }} 
              onClick={onSwitchToSignup}
            >
              Sign up here
            </span>
          </p>
          
          <button onClick={handlePasswordReset} style={{
            background: 'none',
            border: 'none',
            color: '#2196F3',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: 14,
            marginTop: 15
          }}>
            Forgot your password?
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
